var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center",attrs:{"fluid":""}},[_c('WelcomeMobile',{staticClass:"d-sm-none d-block"}),_c('WelcomeDesktop',{staticClass:"d-none d-sm-block"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }